<template>
  <div class="mt-5">
    <mdbRow class="align-items-center">
      <mdbCol>
        <h6>ID: {{ customerId }}</h6>
      </mdbCol>
      <mdbCol>
        <mdbInput
          v-model="tel"
          :label="$t('change_member_phonenumber_input_label')"
          :small="$t('change_member_phonenumber_input_small')"
          type="text"
        />
      </mdbCol>
      <mdbCol>
        <mdbBtn color="indigo" @click="changePhoneNumber">{{
          $t("change_member_new_phonenumber_button")
        }}</mdbBtn>
      </mdbCol>
    </mdbRow>
  </div>
</template>

<script>
import { mdbRow, mdbCol, mdbBtn, mdbInput } from "mdbvue";
export default {
  name: "ChangeMemberPhonenumber",
  components: {
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbInput,
  },
  props: {
    customerId: String,
  },
  data() {
    return {
      tel: "",
      changephonenumberpath: "/1.0/front/customer/change/phonenumber",
    };
  },
  methods: {
    phoneSearch(val) {
      this.findPhoneNumber(val);
    },
    changePhoneNumber() {
      this.postData = JSON.stringify({
          sessionid: this.$store.getters.getToken,
          tel: this.tel,
          id: this.customerId
        });
      this.$http
        .post(this.changephonenumberpath, this.postData)
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("change_member_new_phonenumber_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort
            });
          } else {
            this.$notify.error({
              message: this.$t("change_member_new_phonenumber_error"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutmedium
            });
          }
        })
        .catch((error) => {
        if (error.response.status == 409) {
            this.$notify.error({
              message: this.$t("change_member_new_phonenumber_duplicate"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutmedium
            });
            return error;
          }
          this.$notify.error({
              message: this.$t("change_member_new_phonenumber_error"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutmedium
            });
          return error;
        });
    },
  },
};
</script>

<style scoped>
.active-cyan input[type="text"] {
  border: 1px solid indigo;
  box-shadow: 0 1px 0 0 indigo;
}
</style>
